<template>
  <v-container fluid fill-height>
    <v-layout alig-start>
      <v-flex>
        <!-- Listado de empresa -->
        <v-data-table :loading="loading" :headers="headers" :items="empresa" disable-pagination hide-default-footer
          class="elevation-3">
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>EMPRESA</v-toolbar-title>
              <v-divider class="mx-2 hidden-sm-and-down" inset vertical></v-divider>
              <v-spacer />
              <!-- Modificar empresa -->
              <v-dialog v-model="dialog" max-width="500px" persistent>
                <v-card>
                  <v-toolbar dark dense class="primary" flat>
                    <v-toolbar-title>Actualizar Empresa</v-toolbar-title>
                  </v-toolbar>
                  <v-card-text>
                    <v-form v-model="isValid">
                      <v-row class="mt-2">
                        <v-col cols="12" align="center">
                          <template color="teal" v-if="file">
                            <v-layout justify-center>
                              <v-img max-width="100" :src="urlTemporal" @click="$refs.boton.click()" />
                            </v-layout>
                          </template>
                          <template color="teal" v-else>
                            <v-layout justify-center>
                              <v-img max-width="100" :src="'data:image/png;base64,' + logo"
                                @click="$refs.boton.click()" />
                            </v-layout>
                          </template>
                          <input type="file" id="file" ref="boton" accept=".png, .jpg, .jpeg"
                            @change="buscarImagen($event)" class="d-none" />
                        </v-col>
                        <v-col cols="12">
                          <v-text-field dense v-model.trim="dscempresa" label="Nombre"
                            :rules="[v => !!v || 'Nombre requerido', v => (!!v && v.length >= 3 && v.length <= 50) || 'Nombre debe tener entre 3 a 50 caracteres', Rules.unespacio]"
                            maxlength="50" prepend-inner-icon="business" v-uppercase hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4">
                          <v-text-field dense v-model.trim="ruc" label="RUC"
                            :rules="[v => !!v || 'Requerido', v => (!!v && v.length == 11) || 'El RUC debe tener 11 caracteres']"
                            maxlength="11" prepend-inner-icon="featured_play_list" hide-details></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="8">
                          <v-text-field dense v-model.trim="direccion" label="Dirección"
                            :rules="[v => !!v || 'Requerido', v => (!!v && v.length >= 3 && v.length <= 50) || 'Dirección debe tener entre 3 a 50 caracteres', Rules.unespacio]"
                            maxlength="60" prepend-inner-icon="place" v-uppercase hide-details></v-text-field>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card-text>
                  <v-card-actions class="py-0 pb-4 px-4 justify-center">
                    <v-btn text color="error" @click="close" small>
                      <v-icon left>close</v-icon>Cancelar
                    </v-btn>
                    <v-btn text color="primary" @click="guardar" :loading="desabilitar"
                      :disabled="desabilitar || !isValid" small>
                      <v-icon left>check</v-icon>Guardar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <!-- Fin Modificar empresa -->
            </v-toolbar>
          </template>

          <!-- Opción -->
          <template v-slot:item.logo="{ item }">
            <template>
              <img height="30px" :src="'data:image/png;base64,' + item.logo" />
            </template>
          </template>
          <template v-slot:item.opciones="{ item }">
            <v-btn x-small icon>
              <v-icon color="primary" @click="editItem(item)">edit</v-icon>
            </v-btn>
          </template>
          <!-- Fin Opción -->
        </v-data-table>
        <!-- Fin Listado de empresa -->
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      empresa: [],
      dialog: false,
      headers: [
        { text: "Logo", value: "logo", sortable: false },
        { text: "Razón Social", value: "dscempresa", sortable: false },
        { text: "RUC", value: "ruc", sortable: false },
        { text: "Dirección", value: "direccion", sortable: false },
        { text: "Opc.", value: "opciones", sortable: false, width: 10 },
      ],
      idempresa: "",

      dscempresa: "",
      ruc: "",
      direccion: "",
      logo: "",

      file: null,
      urlTemporal: "",

      adModal: 0,
      adAccion: 0,
      adNombre: "",
      adId: "",

      desabilitar: false,

      isValid: true,

      /* Validaciones */
      Rules: {
        sinespacio: (v) =>
          (v || "").indexOf(" ") < 0 || "No se permite espacios",
        unespacio: (v) =>
          (v || "").indexOf("  ") < 0 || "No se permite mas de 1 espacio",
      },
    };
  },

  computed: {},

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.listar();
  },

  methods: {
    ...mapActions(["snackBar"]),

    listar() {
      let me = this;
      me.loading = true;

      axios.get("api/Empresas/Listar")
        .then(function (response) {
          //console.log(response);
          me.empresa = response.data;
          me.loading = false;
        })
        .catch(function (error) {
          //console.log(error);
        });
    },

    guardar() {
      // Editar
      let me = this;
      me.desabilitar = true;

      axios.put("api/Empresas/Actualizar", {
        idempresa: me.idempresa,
        dscempresa: me.dscempresa,
        ruc: me.ruc,
        direccion: me.direccion,
        logo: me.logo,
      })
        .then(function (response) {
          me.desabilitar = false;
          me.snackBar({ cl: "success", msg: response.data });
          me.close();
          me.listar();
          me.limpiar();
        })

        .catch(function (error) {
          me.desabilitar = false;
          me.snackBar({ cl: "error", msg: error.response.data });
        });
    },

    editItem(item) {
      this.idempresa = item.idempresa;
      this.dscempresa = item.dscempresa;
      this.ruc = item.ruc;
      this.direccion = item.direccion;
      this.logo = item.logo;
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.limpiar();
    },

    limpiar() {
      this.idempresa = "";
      this.dscempresa = "";
      this.ruc = "";
      this.direccion = "";
      this.logo = "";
      this.file = null;
      this.urlTemporal = "";
      this.mensajeEmpresa = "";

      // Limpiamos input carga de imagen
      document.getElementById("file").value = [];
    },

    buscarImagen(event) {
      //console.log(event.target.files[0]);
      const fileCargado = event.target.files[0];
      // Verificamos si tenemos imagen en fileCargado
      if (fileCargado) {
        const reader = new FileReader();
        reader.readAsDataURL(fileCargado);
        reader.onload = (e) => {
          this.urlTemporal = e.target.result; // Visualizamos en Base64
        };

        // Reducimos imagen con un ancho de 200px
        var resizeImage = function (settings) {
          var file = settings.file;
          var maxSize = settings.maxSize;
          var reader = new FileReader();
          var image = new Image();
          var canvas = document.createElement("canvas");
          var dataURItoBlob = function (dataURI) {
            var bytes =
              dataURI.split(",")[0].indexOf("base64") >= 0
                ? atob(dataURI.split(",")[1])
                : unescape(dataURI.split(",")[1]);
            var mime = dataURI.split(",")[0].split(":")[1].split(";")[0];
            var max = bytes.length;
            var ia = new Uint8Array(max);
            for (var i = 0; i < max; i++) ia[i] = bytes.charCodeAt(i);
            return new Blob([ia], { type: mime });
          };
          var resize = function () {
            var width = image.width;
            var height = image.height;
            if (width > height) {
              if (width > maxSize) {
                height *= maxSize / width;
                width = maxSize;
              }
            } else {
              if (height > maxSize) {
                width *= maxSize / height;
                height = maxSize;
              }
            }
            canvas.width = width;
            canvas.height = height;
            canvas.getContext("2d").drawImage(image, 0, 0, width, height);
            var dataUrl = canvas.toDataURL("image/jpeg");
            //return dataURItoBlob(dataUrl);
            return dataUrl;
          };
          return new Promise(function (ok, no) {
            if (!file.type.match(/image.*/)) {
              no(new Error("Not an image"));
              return;
            }
            reader.onload = function (readerEvent) {
              image.onload = function () {
                return ok(resize());
              };
              image.src = readerEvent.target.result;
            };
            reader.readAsDataURL(file);
          });
        };
        // llamamos a funcion para reducir imagen a imagen Blob
        resizeImage({
          file: fileCargado,
          maxSize: 200,
        })
          .then((resizedImage) => {
            this.logo = resizedImage.replace("data:image/jpeg;base64,", ""); // Cargamos imagen reducida para guardar y reemplazamos data... x un valor vacio
          })
          .catch((err) => {
            console.error(err);
          });
        // Fin Reducimos imagen con un ancho de 700px
      }
    },
  },
};
</script>